import { render, staticRenderFns } from "./ChatWrapper.vue?vue&type=template&id=24a79937"
import script from "./ChatWrapper.vue?vue&type=script&lang=ts"
export * from "./ChatWrapper.vue?vue&type=script&lang=ts"
import style0 from "./ChatWrapper.vue?vue&type=style&index=0&id=24a79937&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24a79937')) {
      api.createRecord('24a79937', component.options)
    } else {
      api.reload('24a79937', component.options)
    }
    module.hot.accept("./ChatWrapper.vue?vue&type=template&id=24a79937", function () {
      api.rerender('24a79937', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat-components/ChatWrapper.vue"
export default component.exports